/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodDonation from './blood-donation';
import BloodDonationDetail from './blood-donation-detail';
import BloodDonationUpdate from './blood-donation-update';
import BloodDonationDeleteDialog from './blood-donation-delete-dialog';

const BloodDonationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodDonation />} />
    <Route path="new" element={<BloodDonationUpdate />} />
    <Route path=":id">
      <Route index element={<BloodDonationDetail />} />
      <Route path="edit" element={<BloodDonationUpdate />} />
      <Route path="delete" element={<BloodDonationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodDonationRoutes;
